<script>
export default {
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      query: '',
      // list: [],
    }
  },
  computed: {
    options() {
      return this.list.filter((option) => {
        return (
          option.text.toLowerCase().indexOf(this.query.toLowerCase()) > -1
          || option.value.title.toLowerCase().indexOf(this.query.toLowerCase()) > -1
          || this.query === ''
        )
      })
    }
  },
  /* watch: {
    query: {
      handler: 'onSearchQuery',
      immediate: true,
    },
  }, */
  mounted() {
    this.$refs['search-input'].focus()
  },
  methods: {
    onClickItem(value) {
      this.$emit('update:value', value);
      this.$emit('change', value);
      this.$parent.close()
    },
  },
}
</script>

<template>
  <div :class="$style.wrapper" style="width: auto">
    <div :class="$style.header">
      <div class="control has-icons-left">
        <input
          ref="search-input"
          v-model="query"
          :class="$style['search-input']"
          class="input"
          type="search"
          placeholder="Search"
        >
        <span class="icon is-left">
          <BaseIcon name="search"/>
        </span>
      </div>
    </div>
    <ul :class="$style['picker-list']">
      <li
        :class="[$style['picker-list__item'], { [$style.isActive]: value === '' }]"
        @click="onClickItem('')"
      >
        <!--多語言-->
        {{ $t('global.MERCHANT_ALL'/*全部商家*/) }}
      </li>
      <li
        v-for="merchant in options"
        :key="merchant.value.alias"
        :class="[$style['picker-list__item'], { [$style.isActive]: value === merchant.value }]"
        @click="onClickItem(merchant.value)"
      >
        {{ merchant.text }}
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
.wrapper {
  background: white;
  height: 600px;
  display: flex;
  flex-direction: column;
  border-radius: $size-section-border-radius;
}
.picker-list {
  overflow: auto;
  &__item {
    padding: 10px 15px;
    color: $color-text-primary;
    cursor: pointer;
    &.isActive {
      color: $color-primary;
    }
    &:hover {
      background-color: rgba(83, 194, 204, 0.1);
    }
  }
}
.header {
  padding: 10px;
  border-bottom: 1px solid $color-border-base;
}
.search-input {
  border-color: transparent;
  color: $grey-light;
  &:hover {
    border-color: transparent;
  }
  &:focus {
    box-shadow: none;
    border-color: transparent;
  }
}
</style>
